import React from 'react';
import css from './DrawerCard.scss';
import PropTypes from "prop-types";

const DrawerCard = (props) =>
     (
        <div className={css['block']} data-role='drawerCardContainer'>
            <div className={css['block-info']}>
                <div className={css['block-header']}>
                    {props.blockIcon}
                    <div className={css['header-info']}>
                        <div data-testid="block-type" role="text">{props.blockType}</div>
                        <div data-testid="block-name" role="text">{props.blockName}</div>
                    </div>
                </div>
                <div className={css['details']}>
                    {props.children}
                </div>
            </div>
            {props.footer}
        </div>
    );

DrawerCard.propTypes = {
    blockType: PropTypes.string.isRequired,
    blockIcon: PropTypes.element.isRequired,
    blockName: PropTypes.string.isRequired,
    footer: PropTypes.element
}

export default DrawerCard;
